import env from 'env';
import io from 'socket.io-client';

const socket = io(env.SOCKETS_DOMAIN, { reconnectionAttempts: 3, reconnectionDelay: 2000 });

export default socket;
